var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#","title":_vm.title},on:{"click":function($event){$event.stopPropagation();return _vm.exportAsCSV(_vm.data)}}},[(_vm.icon)?_c('b-icon',{attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }